/**
 * Company-specific overrides and additions to base help sections
 *
 * Structure:
 * - itemOverrides: Replace specific items by title
 * - additionalItems: Add items to a section (at end or at specific index)
 */

const companyOverrides = {
  'Pampered Chef': {
    2: {
      additionalItems: [
        {
          type: 'document',
          title: 'Forwarding Host & Manually-Entered Orders',
          linkText: 'Forwarding Host & Manually-Entered Orders from Consultants Corner to Connection Point',
          linkUrl: 'https://docs.google.com/document/d/1CW0ctK-lP3GLLSGzBaFJWCpT_rgzIVhc97MriMJCgGk',
          embedUrl: 'https://docs.google.com/document/d/e/2PACX-1vR1bkTC12oGr-ix5_f6dgSIc9uLEu7Ui_To7FNIvFWbeLojMDt_ZaPkVcyK1WoB_s79qQvYHB2mL7Xz/pub?embedded=true',
        },
      ],
    },
    3: {
      additionalItems: [
        {
          type: 'document',
          title: 'Customizing Order Follow-Up Templates Guide',
          linkText: 'Customizing Order Follow-Up Templates Guide',
          linkUrl: 'https://docs.google.com/document/d/1wEEb_-Gxk84kMZrKephi20nduGMJeaS3gqtPbbh7nPo',
          embedUrl: 'https://docs.google.com/document/d/e/2PACX-1vTTGc2eW9AIGyuME6FOUJZPnZoDnzpJ7jAR4ysK2t8Ly6FOALBgV69f0EEfa7YPPiCA8ge0bFqGV2CQ/pub?embedded=true',
        },
      ],
    },
    4: {
      additionalItems: [
        {
          type: 'video',
          title: 'Changing an Event Date',
          vimeoId: '810310000',
        },
      ],
    },
    // Retired: Section 9, Bundle Parties - Pampered Chef specific.
    // If re-added, leave the title unnumbered; HelpSectionAccordion
    // numbers sections sequentially at render time.
    // 9: {
    //   section: {
    //     id: 9,
    //     title: 'Bundle Parties',
    //     subtitle: 'Learn how to create and manage Bundle Parties for your Pampered Chef business',
    //     items: [
    //       {
    //         type: 'video',
    //         title: 'Bundle Parties Tutorial',
    //         vimeoId: '1069659204',
    //       },
    //     ],
    //   },
    // },
  },

  'Jordan Essentials': {
    2: {
      additionalItems: [
        {
          type: 'document',
          title: 'Forwarding Host & Manually-Entered Orders',
          linkText: 'Forwarding Host & Manually-Entered Orders from Consultants Corner to Connection Point',
          linkUrl: 'https://docs.google.com/document/d/1CW0ctK-lP3GLLSGzBaFJWCpT_rgzIVhc97MriMJCgGk',
          embedUrl: 'https://docs.google.com/document/d/e/2PACX-1vR1bkTC12oGr-ix5_f6dgSIc9uLEu7Ui_To7FNIvFWbeLojMDt_ZaPkVcyK1WoB_s79qQvYHB2mL7Xz/pub?embedded=true',
        },
      ],
    },
    3: {
      additionalItems: [
        {
          type: 'document',
          title: 'Customizing Order Follow-Up Templates Guide',
          linkText: 'Customizing Order Follow-Up Templates Guide',
          linkUrl: 'https://docs.google.com/document/d/1wEEb_-Gxk84kMZrKephi20nduGMJeaS3gqtPbbh7nPo',
          embedUrl: 'https://docs.google.com/document/d/e/2PACX-1vTTGc2eW9AIGyuME6FOUJZPnZoDnzpJ7jAR4ysK2t8Ly6FOALBgV69f0EEfa7YPPiCA8ge0bFqGV2CQ/pub?embedded=true',
        },
      ],
    },
    4: {
      additionalItems: [
        {
          type: 'video',
          title: 'Changing an Event Date',
          vimeoId: '810310000',
        },
      ],
    },
  },

  Norwex: {
    3: {
      additionalItems: [
        {
          type: 'document',
          title: 'Customizing Order Follow-Up Templates Guide',
          linkText: 'Customizing Order Follow-Up Templates Guide',
          linkUrl: 'https://docs.google.com/document/d/1r0RN62O-1phq-2fWVrlkIDSRPX7EHufnny6GAJhfMPI',
          embedUrl: 'https://docs.google.com/document/d/e/2PACX-1vRuYqK5KTFRKjxr7K82Txbjm1cKki9Qu9E_MWA0pn6qUR2rTvtqi7MY5TyctNFX-sd8lCljE8lB8540/pub?embedded=true',
        },
      ],
    },
  },

  'Park Lane': {
    3: {
      additionalItems: [
        {
          type: 'document',
          title: 'Customizing Message Templates Guide',
          linkText: 'Customizing Message Templates Guide',
          linkUrl: 'https://docs.google.com/document/d/1b_ucHzqcv2RYP_u_dxLAJ0P3kdJHZ5QUx4UXPcevbrU',
          embedUrl: 'https://docs.google.com/document/d/e/2PACX-1vQqww8Q1KQhnpFg3vV5yt_K9QPOHeYcigpKPEuFYi8sB6lLgJBbClEeXcoZztVMxk7lS1A1krYG8n3t/pub?embedded=true',
        },
      ],
    },
  },

  Sipology: {
    3: {
      additionalItems: [
        {
          type: 'document',
          title: 'Customizing Order Follow-Up Templates Guide',
          linkText: 'Customizing Order Follow-Up Templates Guide',
          linkUrl: 'https://docs.google.com/document/d/1HmEqWT2zL5xxUIzyyIC80Ovl5yc6E4Mh380mKHcZHU8',
          embedUrl: 'https://docs.google.com/document/d/e/2PACX-1vSmKo5roDiT2FsvqLy2Z3Y7Geo9iGGQcdAxKNhXKvugKawBex5Uyk7RBYbhNdHwaFndB9vDnmdGgqN7/pub?embedded=true',
        },
      ],
    },
  },

  // Companies that use the same content as Pampered Chef
  Crunchi: 'Pampered Chef',
  'Thirty-One': 'Pampered Chef',
  'Color Street': 'Pampered Chef',
};

/**
 * Get the effective overrides for a company
 * Handles aliases (e.g., 'Crunchi' -> 'Pampered Chef')
 */
export const getCompanyOverrides = (company) => {
  if (!company) return {};

  const override = companyOverrides[company];

  // If it's a string, it's an alias to another company
  if (typeof override === 'string') {
    return companyOverrides[override] || {};
  }

  return override || {};
};

export default companyOverrides;
